export default from './members-placeholder';



// WEBPACK FOOTER //
// ./app/components/members-placeholder/index.js